<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item>Login</b-breadcrumb-item>
      <b-breadcrumb-item active>Dashboard</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="page-title">Dashboard</h1>
    <b-row>
      <b-col md="6">
        <Widget title="<h2>Prihlásenie </h2>" customHeader collapse>
          <b-row>
            <b-col md="6">
              Token: 
            </b-col>
            <b-col >
              <span v-if="token">{{token}}</span><span v-else style="color:red;">Neplatný token</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              Meno: 
            </b-col>
            <b-col >
              {{user.firstname}}
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              Priezvisko: 
            </b-col>
            <b-col >
              {{user.lastname}}
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              Počet odoslaných formulárov: 
            </b-col>
            <b-col >
              {{user.submittedFormsCount}}
            </b-col>
          </b-row>
          <template v-if="user.activeContract">
          <b-row>
            <b-col md="6">
              Aktuálna zákazka: 
            </b-col>
            <b-col >
              {{user.activeContract.title}}
            </b-col>
          </b-row>
          </template>
        </Widget>
      </b-col>
      <b-col md="6">
        <Widget title="<h2>Zákazky:</h2>" customHeader collapse>
          <b-button block variant="primary" :disabled="!validToken" @click.prevent="goToOrdersPage()">
            <span >Vyžrebovať zákazku</span>
          </b-button>
        </Widget>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import "imports-loader?jQuery=jquery,this=>window!flot";
import "imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.pie";
/* eslint-enable */
import Widget from "@/components/Widget/Widget";

export default {
  name: "Dashboard",
  components: { Widget },
  data: function () {
    return {
      token: this.$route.params.token,
      user: {}
    }
  },
  created: async function () {
    let response = await this.$transparexHttp.get('/users/token/' + this.token)
    if (response.status === 200) {
      this.user = response.data
    }
  },
  methods: {
    goToOrdersPage: function() {
      let token = this.token
      this.$router.push({ name: 'FormularPage', params: { token }})
    }
  },
  computed: {
    validToken: function() {
      return !!this.token;
    }
  }
};
</script>

<style src="./Dashboard.scss" lang="scss" scoped />
